import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import TextUnderline from '@components/TextUnderline';
import colors from '@constants/colors';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import styles from './styles.module.scss';

interface Params {
    href: string;
}

const ExternalShopModal: ActivityComponentType<Params> = () => {
  const { pop } = useFlow();
  return (
        <Modal>
            <ModalContainer>
                <Column align='center' className={styles.container}>
                    <TextUnderline>
                        <Text size='3xl' fontWeight='bold'>
                            행정복지센터점
                        </Text>
                    </TextUnderline>
                    <Text className={styles.warning} size='xl'>
                        2km 반경 밖 매장입니다<br/>
                        <span>그래도 주문할까요?</span>
                    </Text>
                    <Text className={styles.ment} color={colors.gray6}>
                        매장에서 주문 확인 후 주문 취소가 불가합니다.
                    </Text>
                    <Button fullWidth className={styles.cancel}
                            variant='tertiary'
                            onClick={pop} >
                        취소
                    </Button>
                    <Button fullWidth>
                        주문하기
                    </Button>
                </Column>
            </ModalContainer>
        </Modal>
  );
};

export default ExternalShopModal;
